import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';

export const LoadingButtonStyled = styled(LoadingButton)`
  .MuiLoadingButton-loadingIndicator {
    color: white;
  }
`;
